import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 6rem 0 0 2rem;
  background-color: ${COLORS.GRAY};
  height: 100vh;
`;

export const StyledHeaderButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledTextButton = styled(Button)`
  &&& {
    background: transparent;
    border: none;
    max-height: 1.5rem;
    text-transform: uppercase;
    line-height: 1;
    padding: 0;
    width: fit-content;
  }

  &&& svg {
    transform: rotate(90deg);
    fill: ${COLORS.CHARCOAL};
  }

  &&&:hover {
    background: transparent;
    border: none;
  }
`;

export const StyledCancelButton = styled(Button)`
  &&& {
    background: transparent;
    border: none;
    line-height: 1;
    padding: 0;
    width: fit-content;
  }

  &&&:hover {
    background: transparent;
    border: none;
  }
`;

export const StyledCancelIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${COLORS.CHARCOAL};
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 0.5rem;

  &&& svg {
    fill: ${COLORS.CHARCOAL};
    height: 0.75rem;
    width: 0.75rem;
  }
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledHeaderLeftBlock = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const StyledHeaderRightBlock = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding-right: 2rem;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
`;

export const StyledContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 22vw;
  background: ${COLORS.WHITE};
  overflow: hidden;
`;
